<template>
  <div class="authorization w1200">
    <p class="f20 fb mar20-b" v-if="isOpenType == 0">授权并发布小程序</p>
    <p class="f20 fb mar20-b" v-if="isOpenType == 1">创建并发布小程序</p>
    <el-steps direction="vertical" :active="active">
      <template v-if="isOpenType == 1">
        <el-step class="f16" title="快速创建小程序">
          <template slot="description">
            <div class="mar30-b flex items-center">
              <div class="pad50-r flex1">
                <p class="gray9 f12 mar10-t">
                  填写<span class="red">法人实名认证过的微信号</span>,填写<span class="red">工商信息</span>， 引导<span class="red">法人扫脸完成认证</span
                  >，认证成功后， 完善小程序名称、头像基本信息即可获得一个正式在微信内可搜索的小程序。
                </p>
                <a class="blue f12 mar10-t" :href="`https://znt.com.cn/postdetail?id=918946`" target="_blank">法人操作教程</a>
              </div>
              <div>
                <el-button
                  type="primary"
                  v-if="appletInfo == null || appletInfo.appId == '' || (appletInfo && appletInfo.regStatus == 1)"
                  @click="regVisible = true"
                  >立即创建</el-button
                >
                <div class="f16" v-if="appletInfo && appletInfo.appId != '' && appletInfo.regStatus == 2">
                  <i class="el-icon-success mar5-r green"></i>
                  <span class="blue f14">创建成功</span>
                </div>
                <div class="f16" v-if="appletInfo && appletInfo.appId != '' && appletInfo.regStatus == 3">
                  <i class="el-icon-warning mar5-r gray9"></i>
                  <span class="red f14 mar5-r">{{ appletInfo.thirdPartyRegMsg }}</span>
                  <a class="blue f14 flex1 pointer" @click="regVisible = true">修改</a>
                </div>
              </div>
            </div>
          </template>
        </el-step>
        <el-step class="f16" title="设置小程序信息">
          <template slot="description">
            <div class="mar30-b flex items-center">
              <div class="pad50-r flex1">
                <p class="gray9 f12 mar10-t">设置小程序基本信息，生成体验版小程序，查看效果</p>
              </div>
              <div>
                <el-button
                  type="primary"
                  @click="openSetVisible"
                  :disabled="appletInfo == null || appletInfo.appId == '' || (appletInfo && appletInfo.regStatus != 2)"
                  v-if="appletInfo == null || appletInfo.appId == '' || (appletInfo && appletInfo.auditStatus == 0 && appletInfo.isReg)"
                  >立即设置</el-button
                >
                <div
                  class="f16"
                  v-if="appletInfo && appletInfo.isReg && (appletInfo.auditStatus == 1 || appletInfo.auditStatus == 2 || appletInfo.auditStatus == 3)"
                >
                  <i class="el-icon-success mar5-r green" v-if="appletInfo.auditStatus == 3"></i>
                  <span class="mar5-r blue f14" v-if="appletInfo.auditStatus == 3">设置成功</span>
                  <i class="el-icon-warning mar5-r gray9" v-if="appletInfo.auditStatus == 1"></i>
                  <span class="mar5-r" v-if="appletInfo.auditStatus == 1">立即设置</span>
                  <a class="blue f14 flex1 pointer" @click="openSetVisible" v-if="appletInfo && appletInfo.isReg && appletInfo.auditStatus == 1">修改</a>
                  <el-button type="primary" class="mar20-l" @click="getTestQrcodeUrl" :disabled="appletInfo == null || appletInfo.appId == ''">
                    获取体验版</el-button
                  >
                </div>
              </div>
            </div>
          </template>
        </el-step>
        <el-step class="f16" title="完成所有准备，提交审核并发布小程序">
          <template slot="description">
            <div class="mar30-b flex items-center">
              <div class="pad50-r flex1">
                <p class="gray9 f12 mar10-t">提交微信审核（最长14个工作日），审核通过后即可立即发布版本</p>
              </div>
              <div>
                <el-button
                  type="primary"
                  v-if="
                    appletInfo == null || appletInfo.appId == '' || (appletInfo && appletInfo.isReg && appletInfo.isRelease == 0 && appletInfo.auditStatus == 1)
                  "
                  @click="getSubmit"
                  :disabled="appletInfo == null || appletInfo.appId == '' || (appletInfo && appletInfo.auditStatus != 1)"
                  >提交审核</el-button
                >
                <el-button
                  type="primary"
                  v-if="appletInfo && appletInfo.isReg && appletInfo.isRelease == 0 && appletInfo.regStatus == 2 && appletInfo.auditStatus == 2"
                  @click="getSubmit"
                  :disabled="true"
                  >审核中</el-button
                >
                <div class="f16" v-if="appletInfo && appletInfo.isReg && appletInfo.isRelease == 1">
                  <i class="el-icon-success mar5-r green"></i>
                  <span>发布成功</span>
                </div>
              </div>
            </div>
          </template>
        </el-step>
      </template>
      <template v-if="isOpenType == 0">
        <el-step class="f16" title="已注册微信小程序，立即授权发布">
          <template slot="description">
            <div class="mar30-b flex items-center">
              <div class="pad50-r flex1">
                <p class="gray9 f12 mar10-t">
                  使用微信小程序管理员帐号扫码进行授权，授权过程中请勾选所有权限以确保小程序功能完整性。如未注册小程序，可以从公众号后台免微信认证创建小程序或直接前往“微信公众平台”注册企业主体的小程序帐号。
                </p>
                <a class="blue f12 mar10-t" :href="`https://mp.weixin.qq.com/`" target="_blank">官方注册小程序</a>
              </div>
              <div>
                <el-button type="primary" v-if="appletInfo == null || appletInfo.appId == ''" @click="queryAuthUrl" :disabled="appletInfo ? true : false"
                  >立即授权</el-button
                >
                <div class="f16" v-if="appletInfo && appletInfo.appId != ''">
                  <i class="el-icon-success mar5-r green"></i>
                  <span class="blue f14">授权成功</span>
                </div>
              </div>
            </div>
          </template>
        </el-step>
        <el-step class="f16" title="设置小程序信息">
          <template slot="description">
            <div class="mar30-b flex items-center">
              <div class="pad50-r flex1">
                <p class="gray9 f12 mar10-t">设置小程序基本信息，生成体验版小程序，查看效果</p>
              </div>
              <div>
                <el-button
                  type="primary"
                  @click="openSetVisible"
                  :disabled="appletInfo == null || appletInfo.appId == ''"
                  v-if="appletInfo == null || appletInfo.appId == '' || (appletInfo && appletInfo.auditStatus == 0)"
                  >立即设置</el-button
                >
                <div class="f16" v-if="appletInfo && (appletInfo.auditStatus == 1 || appletInfo.auditStatus == 2 || appletInfo.auditStatus == 3)">
                  <i class="el-icon-success mar5-r green" v-if="appletInfo.auditStatus == 3"></i>
                  <span class="mar5-r blue f14" v-if="appletInfo.auditStatus == 3">设置成功</span>
                  <i class="el-icon-warning mar5-r gray9" v-if="appletInfo.auditStatus == 1"></i>
                  <span class="mar5-r" v-if="appletInfo.auditStatus == 1">立即设置</span>
                  <a class="blue f14 flex1 pointer" @click="openSetVisible" v-if="appletInfo && appletInfo.auditStatus == 1">修改</a>
                  <el-button type="primary" class="mar20-l" @click="getTestQrcodeUrl" :disabled="appletInfo == null || appletInfo.appId == ''">
                    获取体验版</el-button
                  >
                </div>
              </div>
            </div>
          </template>
        </el-step>
        <el-step class="f16" title="完成所有准备，提交审核并发布小程序">
          <template slot="description">
            <div class="mar30-b flex items-center">
              <div class="pad50-r flex1">
                <p class="gray9 f12 mar10-t">提交微信审核（最长14个工作日），审核通过后即可立即发布版本</p>
              </div>
              <div>
                <el-button
                  type="primary"
                  v-if="appletInfo == null || appletInfo.appId === '' || (appletInfo && appletInfo.isRelease == 0 && appletInfo.auditStatus == 1)"
                  @click="getSubmit"
                  :disabled="appletInfo == null || (appletInfo && appletInfo.auditStatus != 1)"
                  >提交审核</el-button
                >
                <el-button type="primary" v-if="appletInfo && appletInfo.isRelease == 0 && appletInfo.auditStatus == 2" @click="getSubmit" :disabled="true"
                  >审核中</el-button
                >
                <div class="f16" v-if="appletInfo && appletInfo.isRelease == 1">
                  <i class="el-icon-success mar5-r green"></i>
                  <span>发布成功</span>
                </div>
              </div>
            </div>
          </template>
        </el-step>
      </template>
    </el-steps>
    <el-dialog title="" :close-on-click-modal="false" :visible.sync="autVisible" width="500px">
      <div class="text-center">
        <img class="w200" :src="authUrl" alt="" />
      </div>
      <div class="text-center" v-if="authUrlType == 1">
        <p>请使用小程序管理员账号扫码授权</p>
      </div>
      <div class="text-center" v-if="authUrlType == 2">
        <p>温馨提示：请使用小程序主账号扫码体验</p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="autVisible = false">取 消</el-button>
        <el-button v-if="authUrlType == 1" type="primary" @click="getAppletInfo">确 定</el-button>
        <el-button v-if="authUrlType == 2" type="primary" @click="autVisible = false">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="设置小程序" :close-on-click-modal="false" :visible.sync="setVisible" width="600px">
      <div class="pad20-lr">
        <el-form ref="setSubForm" :model="setSubForm" :rules="setRules" label-width="120px">
          <el-form-item label="小程序名称：" prop="title">
            <el-input v-model="setSubForm.title" placeholder="请填写小程序名称"></el-input>
          </el-form-item>
          <el-form-item label="分享封面图：" prop="shareUrl">
            <!-- <el-input v-model="setSubForm.shareImg" placeholder="请填写分享封面图"></el-input> -->
            <el-upload
              class="share-uploader"
              :action="`${env.VUE_APP_fileserver}persistentUpload`"
              :show-file-list="false"
              :on-success="shareSuccess"
              :before-upload="uploadBefore"
            >
              <img v-if="setSubForm.shareImg" :src="setSubForm.shareImg" class="avatar" />
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </el-form-item>
          <el-form-item label="登录logo：" prop="loginUrl">
            <!-- <el-input v-model="setSubForm.shopIcon" placeholder="请填写登录logo"></el-input> -->
            <el-upload
              class="share-uploader"
              :action="`${env.VUE_APP_fileserver}persistentUpload`"
              :show-file-list="false"
              :on-success="shopSuccess"
              :before-upload="uploadBefore"
            >
              <img v-if="setSubForm.shopIcon" :src="setSubForm.shopIcon" class="avatar" />
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </el-form-item>
          <el-form-item class="is-required" label="皮肤设置：" prop="theme">
            <ul class="flex skin-list">
              <li v-for="item in themeList" :key="item.theme" class="mar15-r" @click="changeSkin(item.theme)">
                <div class="skin pointer relative" :class="item.bgColor">
                  <div class="absolute skin-icon" v-if="setSubForm.theme === item.theme">
                    <img class="absolute" :src="item.icon" />
                  </div>
                  <img class="absolute skin-example" :src="item.example" />
                </div>
                <p class="text-center">{{ item.name }}</p>
              </li>
            </ul>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="setVisible = false">取 消</el-button>
        <el-button type="primary" :loading="buttonLoading" @click="codeComit">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="注册小程序" :close-on-click-modal="false" :visible.sync="regVisible" width="600px">
      <div class="pad10_b">
        <el-alert title="注：信息填写错误导致“代注册提交失败”，请于24小时后重新编辑提交" type="warning" show-icon> </el-alert>
      </div>
      <div class="pad20-lr">
        <el-form ref="setRegForm" :model="setRegForm" :rules="regRules" label-width="140px">
          <el-form-item label="法人微信号：" prop="wxName">
            <el-input v-model="setRegForm.wxName" placeholder="请填写法人微信号"></el-input>
          </el-form-item>
          <el-form-item label="法人姓名：" prop="name">
            <el-input v-model="setRegForm.name" placeholder="请填写法人姓名"></el-input>
          </el-form-item>
          <el-form-item label="企业名称：" prop="orgName">
            <el-input v-model="setRegForm.orgName" placeholder="请填写企业名称"></el-input>
          </el-form-item>
          <el-form-item label="代码类型：" prop="codeType">
            <el-select v-model="setRegForm.codeType" placeholder="请选择活动区域">
              <el-option label="统一社会信用代码" :value="1"></el-option>
              <el-option label="组织机构代码" :value="2"></el-option>
              <el-option label="营业执照注册号" :value="3"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="社会信用代码：" prop="orgCode">
            <el-input v-model="setRegForm.orgCode" placeholder="请填写社会信用代码"></el-input>
          </el-form-item>
          <el-form-item label="客服电话：" prop="phone">
            <el-input v-model="setRegForm.phone" placeholder="请填写客服电话"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="regVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitReg" :disabled="appletInfo && (appletInfo.regStatus == 1 || appletInfo.regStatus == 2)" :loading="buttonLoading"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<style lang="scss" scoped>
@import "./index.scss";
</style>
<style>
.shopInfoMag .el-message-box__headerbtn:focus .el-message-box__close,
.shopInfoMag .el-message-box__headerbtn:hover .el-message-box__close {
  color: #909399;
}
.shopInfoMag .el-button--default:hover,
.shopInfoMag.el-button--default:focus {
  background: #ffffff;
  border: 1px solid #dcdfe6;
  color: #606266;
}
.shopInfoMag .el-button--primary,
.shopInfoMag .el-button--primary:hover,
.shopInfoMag.el-button--primary:focus {
  background-color: #0095f1;
  border-color: #0095f1;
  color: #fff;
}
</style>
<script>
// import { Loading } from "element-ui";

export default {
  data() {
    return {
      env: process.env,
      active: 0,
      isOpenType: "",
      authUrl: "",
      authUrlType: 1,
      autVisible: false,
      setVisible: false,
      buttonLoading: false,
      regVisible: false,
      setSubForm: {
        title: "",
        ucHideAppId: "",
        appId: "",
        shopIcon: "",
        shareImg: "",
        sellFlag: false,
        theme: "theme1",
        templateId: "",
      },
      themeList: [
        {
          name: "清新绿",
          theme: "theme1",
          bgColor: "bg-green",
          icon: "https://cmscenter-files.nxin.com/nxsc/miniProgram/green-icon.png",
          example: "https://cmscenter-files.nxin.com/nxsc/miniProgram/green-example.png",
        },
        {
          name: "日光橙",
          theme: "theme3",
          bgColor: "bg-orange",
          icon: "https://cmscenter-files.nxin.com/nxsc/miniProgram/orange-icon.png",
          example: "https://cmscenter-files.nxin.com/nxsc/miniProgram/orange-example.png",
        },
        {
          name: "鲜艳红",
          theme: "theme4",
          bgColor: "bg-red",
          icon: "https://cmscenter-files.nxin.com/nxsc/miniProgram/red-icon.png",
          example: "https://cmscenter-files.nxin.com/nxsc/miniProgram/red-example.png",
        },
      ],
      template_list: [],
      setRegForm: {
        wxName: "",
        name: "",
        orgName: "",
        orgCode: "",
        phone: "",
        id: "",
        codeType: 1,
      },
      setRules: {
        title: [
          {
            required: true,
            message: "请输入小程序名称",
            trigger: "blur",
          },
        ],
        shareUrl: [
          {
            required: true,
            message: "请输入分享封面图地址",
            trigger: "blur",
          },
        ],
        loginUrl: [
          {
            required: true,
            message: "请输入登录logo地址",
            trigger: "blur",
          },
        ],
      },
      regRules: {
        name: [
          {
            required: true,
            message: "请填写法人姓名",
            trigger: "blur",
          },
        ],
        wxName: [
          {
            required: true,
            message: "请填写法人微信号",
            trigger: "blur",
          },
        ],
        orgName: [
          {
            required: true,
            message: "请填写企业名称",
            trigger: "blur",
          },
        ],
        orgCode: [
          {
            required: true,
            message: "请填写社会信用代码",
            trigger: "blur",
          },
        ],
        phone: [
          {
            required: true,
            message: "请填写客服电话",
            trigger: "blur",
          },
        ],
      },
      appletInfo: null,
    };
  },
  created() {
    if (/(nxin.com)$/.test(window.location.host)) {
      document.domain = "nxin.com";
    }
    if (/(dbn.cn)$/.test(window.location.host)) {
      document.domain = "dbn.cn";
    }
    this.isOpenType = this.$route.params.isOpenType;
    if (this.isOpenType === "") {
      return;
    }
    this.$store.dispatch("shop/shop/getPackageGoods").then((data) => {
      this.template_list = data.data.template_list;
    });
    if (this.isOpenType === "0") {
      if (this.appletInfo) {
        return;
      }
      this.$store.dispatch("applet/applet/getAppletInfo", { regType: this.isOpenType }).then((res) => {
        if (res) {
          this.$store.dispatch("applet/applet/getShopAppletInfo", { appId: res.appId }).then((resA) => {
            if (resA) {
              this.appletInfo = resA;
              this.$set(this.appletInfo, "isReg", false);
              this.getActive();
            }
          });
        }
        this.autVisible = false;
      });
    }
    if (this.isOpenType === "1") {
      this.getShopAppletInfo();
    }
  },
  methods: {
    getActive() {
      if (this.appletInfo == null || this.appletInfo.appId == "") {
        this.active = 0;
      } else if (this.appletInfo && (this.appletInfo.authorizationStatus == 1 || this.appletInfo.regStatus == 2) && this.appletInfo.auditStatus == 0) {
        this.active = 1;
      } else if (this.appletInfo && (this.appletInfo.auditStatus == 1 || this.appletInfo.auditStatus == 2)) {
        this.active = 2;
      } else {
        this.active = 0;
      }
    },
    // 获取小程序内容
    getAppletInfo() {
      window.location.reload(true);
    },
    // 获取注册小程序内容
    getShopAppletInfo() {
      this.$store.dispatch("applet/applet/getShopAppletInfo", { regStatus: this.isOpenType }).then((res) => {
        if (res) {
          this.appletInfo = res;
          this.$set(this.appletInfo, "isReg", true);
          this.setRegForm.name = res.legalPersonName;
          this.setRegForm.wxName = res.wechatNumber;
          this.setRegForm.orgCode = res.creditCode;
          this.setRegForm.orgName = res.orgName;
          this.setRegForm.phone = res.servicePersonPhone;
          this.setRegForm.id = res.id;
          this.autVisible = false;
          this.getActive();
        }
      });
      console.log(this.appletInfo);
    },
    // 获取授权二维码
    queryAuthUrl() {
      this.$store.dispatch("applet/applet/getAuthUrl").then((res) => {
        if (res && res.code == 0) {
          this.authUrlType = 1;
          this.authUrl = res.data;
          this.autVisible = true;
        } else {
          this.$message.success(res.msg + ",错误码：" + res.code);
        }
      });
    },
    // 获取体验版二维码
    getTestQrcodeUrl() {
      if (!this.appletInfo) {
        return;
      }
      this.$store.dispatch("applet/applet/getTestQrcodeUrl", { ucAppId: this.appletInfo.platformId }).then((res) => {
        if (res && res.code == 0) {
          this.authUrlType = 2;
          this.authUrl = res.data;
          this.autVisible = true;
        } else {
          this.$message.success(res.msg + ",错误码：" + res.code);
        }
      });
    },
    // 注册小程序
    submitReg() {
      this.buttonLoading = true;
      if (this.setRegForm.wxName == "" || this.setRegForm.name == "" || this.setRegForm.orgName == "" || this.setRegForm.orgCode == "") {
        this.$message.error("请输入正确的小程序信息");
        this.buttonLoading = false;
        return;
      }
      this.$store.dispatch("applet/applet/getFastReg", this.setRegForm).then((res) => {
        if (res.code === "0") {
          this.$message.success("注册中……");
          this.regVisible = false;
          this.buttonLoading = false;
          window.location.reload(true);
        } else {
          this.buttonLoading = false;
          this.$message.error(res.msg + ",错误码：" + res.code);
        }
      });
    },
    // 小程序设置
    codeComit() {
      this.buttonLoading = true;
      if (this.setSubForm.title == "" || this.setSubForm.shareImg == "" || this.setSubForm.shopIcon == "") {
        this.$message.error("必填项为空");
        this.buttonLoading = false;
        return;
      }
      this.setSubForm.appId = this.appletInfo.appId;
      this.setSubForm.ucHideAppId = this.appletInfo.platformId;
      this.$store.dispatch("applet/applet/getCommitAppletInfo", this.setSubForm).then((res) => {
        if (res.code === "0") {
          this.$message.success("设置成功");
          this.setVisible = false;
          this.buttonLoading = false;
          window.location.reload(true);
        } else {
          this.buttonLoading = false;
          this.$message.error(res.msg + ",错误码：" + res.code);
        }
      });
    },
    // 提交审核
    getSubmit() {
      const h = this.$createElement;
      this.$msgbox({
        title: "消息",
        message: h("p", null, [h("span", null, "是否提交微信审核，提交后不可更改小程序信息？ ")]),
        showCancelButton: true,
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        customClass: "shopInfoMag",
        beforeClose: (action, instance, done) => {
          if (action === "confirm") {
            instance.confirmButtonLoading = true;
            instance.confirmButtonText = "提交审核中...";
            setTimeout(() => {
              this.$store
                .dispatch("applet/applet/getSubmit", {
                  ucAppId: this.appletInfo.platformId,
                  title: "上线发布",
                  appId: this.appletInfo.appId,
                })
                .then((res) => {
                  if (res.code === "0") {
                    this.$message.success("提交成功");
                    window.location.reload(true);
                  } else {
                    this.$message.error(res.msg + ",错误码：" + res.code);
                  }
                });
            }, 2000);
          } else {
            done();
          }
        },
      });
    },

    // 上传图片之前
    uploadBefore(file) {
      // : { size: any; type: any }
      const { size, type } = file;
      const isVerify = /(jpg|bmp|jpeg|png)$/.test(type);
      const isLt3M = size / 1024 / 1024 < 50;

      if (!isVerify) {
        this.$message.error("上传必须是JPG/BMP/JPEG/PNG/格式");
      } else if (!isLt3M) {
        this.$message.error("上传大小不能超过 50MB");
      }
      // else {
      //   this.loadingInstance = Loading.service({
      //     lock: true,
      //     text: "图片上传中",
      //   });
      // }

      return isVerify && isLt3M;
    },

    // 上传图片成功之后
    shareSuccess(res) {
      const {
        data: { url },
      } = res;
      this.setSubForm.shareImg = url;
    },

    // 上传登录logo成功
    shopSuccess(res) {
      const {
        data: { url },
      } = res;
      this.setSubForm.shopIcon = url;
    },

    changeSkin(theme) {
      this.setSubForm.theme = theme;
      this.template_list.forEach((item) => {
        if (item.themeType === theme) {
          this.setSubForm.templateId = item.template_id;
        }
      });
    },
    openSetVisible() {
      this.setVisible = true;
      this.changeSkin("theme1");
      console.log("this.setSubForm", this.setSubForm);
    },
  },
};
</script>
